// extracted by mini-css-extract-plugin
module.exports = {"copyright":"Copyright-module--copyright--2tDcf"};